import type { UserSubscriptionResponse } from '@hedepy/common/schemas/routes/api/v2/userSubscription'

import type { ServiceType } from '@/legacy-src/types/GeneralStateType'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'

/**
 * The subscribed therapist and service are covered at whatever they cost today; any other pair
 * only at the price the subscription was bought at. `validateSubscriptionBooking.ts` additionally
 * rejects a subscription whose currency differs from the deployment's — unreachable outside the
 * pre-2024 UA currency migration, since the column defaults to the deployment's own currency.
 */
export const getIsCoveredBySubscription = ({
  subscription,
  therapist,
  service,
}: {
  subscription: NonNullable<UserSubscriptionResponse['subscription']>
  therapist: TherapistType
  service: ServiceType
}) => {
  if (subscription.therapist.id === therapist.therapistId && subscription.service.id === service.id) {
    return true
  }

  return therapist.prices?.find(({ serviceId }) => serviceId === service.id)?.price === Number(subscription.initPrice)
}
